import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { isValidUsername } from '../../lib/rules'
import { checkUsername } from './api'

/**
 * Whether a username is free, checked once typing pauses.
 * @param name - What is in the field.
 * @returns The query; disabled while the format is wrong.
 */
export function useUsernameAvailability(name: string) {
  const [debounced, setDebounced] = useState(name)
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(name), 400)
    return () => window.clearTimeout(timer)
  }, [name])

  return useQuery({
    queryKey: ['username', debounced.toLowerCase()],
    queryFn: () => checkUsername(debounced),
    enabled: isValidUsername(debounced),
    staleTime: 30_000,
    retry: false,
  })
}

